export default {
  remittanceAdvices: [],
};
